"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpertAvatar = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const ExpertAvatar = ({ companyInfo, className }) => {
    const agentAvatar = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.agentAvatar) ? companyInfo.agentAvatar : '';
    const agentName = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.agentName) ? companyInfo.agentName : 'Agent';
    const companyName = (companyInfo === null || companyInfo === void 0 ? void 0 : companyInfo.companyName) ? companyInfo.companyName : 'Company';
    return ((0, jsx_runtime_1.jsx)(PulseEffectContainer, Object.assign({ className: className }, { children: (0, jsx_runtime_1.jsxs)(ui_react_1.Column, Object.assign({ style: {
                zIndex: 3,
                marginBottom: '50%',
                justifyContent: 'center',
                alignItems: 'center',
            } }, { children: [(0, jsx_runtime_1.jsx)(PulseEffectCircleLarge, {}), companyInfo ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(PulseEffectWrapperSmall, { children: (0, jsx_runtime_1.jsx)(ui_react_1.Avatar, { src: agentAvatar, displayName: agentName, size: "medium" }) }), (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "white", size: "large", headingFontFamily: true, bold: true }, { children: agentName })), (0, jsx_runtime_1.jsx)(ui_react_1.AppText, Object.assign({ color: "white", headingFontFamily: true }, { children: companyName }))] })) : ((0, jsx_runtime_1.jsx)(ui_react_1.Spinner, { size: "small" }))] })) })));
};
exports.ExpertAvatar = ExpertAvatar;
const PulseEffectCircleLarge = ui_react_1.styled.span({
    width: 50,
    height: 50,
    zIndex: 2,
    borderRadius: '100%',
    position: 'absolute',
    animation: `${ui_react_1.Theme.keyframes.growOutLarge} 1700ms ease-out infinite`,
    backgroundColor: ui_react_1.Theme.colors.azure,
});
const PulseEffectWrapperSmall = ui_react_1.styled.span({
    animation: `${ui_react_1.Theme.keyframes.flexSmall} 1700ms ease-in-out infinite`,
});
const PulseEffectContainer = ui_react_1.styled.div `
    position: absolute;
    top: 15%;
    margin: 0 auto;
    width: 100%;
    z-index: 3;
`;
//# sourceMappingURL=expert_avatar.js.map